export class ScrollLockService {
  private pageLocked = false;

  public lockPage() {
    if (this.pageLocked) return;

    const scrollbarWidth = ScrollLockService.getScrollbarWidth();
    document.body.style.overflow = "hidden";
    document.body.style.paddingRight = `${scrollbarWidth}px`;

    this.pageLocked = true;
  }

  public unlockPage() {
    if (this.pageLocked === false) return;

    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
    document.body.style.height = "";

    this.pageLocked = false;
  }

  static getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }
}

export default new ScrollLockService();
